exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._2__44M3w6bVjwfTtfh6KDK{padding:20px}._3Owm9_STA6SVbf0LZGvsCY{cursor:pointer;white-space:nowrap}html[dir] ._2zwxpHbMoO7bMUVJxBU_SC{padding-top:10px}", ""]);
// Exports
exports.locals = {
	"policyTipPeekContainer": "_2__44M3w6bVjwfTtfh6KDK",
	"link": "_3Owm9_STA6SVbf0LZGvsCY",
	"policyTipButtonContainer": "_2zwxpHbMoO7bMUVJxBU_SC"
};